import { render, staticRenderFns } from "./Kuifeend.vue?vue&type=template&id=2280814b&"
import script from "./Kuifeend.vue?vue&type=script&lang=ts&"
export * from "./Kuifeend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports